function constant(value){return function(){return value}}module.exports=constant;